const setLogoutSucess = () => {
  // console.log(' Logged out saving data to localstorage')
  localStorage.setItem('loggedout', 'yes')
}
export default setLogoutSucess
